import { render } from "./Activity.vue?vue&type=template&id=5a229b7e&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=5a229b7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a229b7e"

export default script